import { render, staticRenderFns } from "./checkWaybillDetail.vue?vue&type=template&id=2fa6bd58&scoped=true"
import script from "./checkWaybillDetail.vue?vue&type=script&lang=js"
export * from "./checkWaybillDetail.vue?vue&type=script&lang=js"
import style0 from "./checkWaybillDetail.vue?vue&type=style&index=0&id=2fa6bd58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa6bd58",
  null
  
)

export default component.exports